/** @format */

import { Node } from './tree.js';
export default class editorHelper {
	static cloneobject(o) {
		var cloned = JSON.parse(JSON.stringify(o));
		return cloned;
	}
	static serialisenode(o) {
		var cache = [];

		var str = JSON.stringify(o, function (key, value) {
			if (key === 'rightNeighbor' || key === 'leftNeighbor') {
				return undefined;
			} else {
				if (typeof value === 'object' && value !== null) {
					if (cache.indexOf(value) !== -1) {
						try {
							return JSON.parse(JSON.stringify(value));
						} catch (error) {
							return value.toObjectString('DELETE');
						}
					}
					cache.push(value);
				}
				return value;
			}
		});
		//var str = o.toObjectString("DELETE");
		return str;
	}
	static deserialisenode(str) {
		let n = JSON.parse(str);
		let n0 = editorHelper.maptonode(n);
		return n0;
	}
	static maptonode(n) {
		let n0 = null;
		if (n != null) {
			n0 = new Node();
			n0.id = parseInt(n.id);
			n0.parentid = parseInt(n.parentid);
			n0.name = n.name;
			n0.type = n.type;
			n0.x = parseInt(n.x);
			n0.y = parseInt(n.y);
			//n0.prelim = n.prelim;
			//n0.modifier = n.modifier;
			n0.width = parseInt(n.width);
			n0.height = parseInt(n.height);
			//n0.span = n.span;
			n0.level = parseInt(n.level);
			n0.connections = [];
			for (var i = 0; i < n.connections.length; i++) {
				var conn = n.connections[i];
				if (typeof conn === 'string') conn = JSON.parse(n.connections[i]);
				if (conn && !conn.line) conn.line = 1;
				conn.overlapOffset = 0;
				if (conn != null) {
					n0.connections.push(conn);
				}
			}
			n0.children = [];
			for (i = 0; i < n.children.length && n.children[i]; i++) {
				//n0.getdescendent(n0.parentid).addchild(editorHelper.maptonode(n.children[i]));
				var child = n.children[i];
				if (typeof child === 'string') child = JSON.parse(n.children[i]);
				let c = editorHelper.maptonode(child);

				if (c != null) {
					n0.addchild(c);
				}
			}
			// n0.leftNeighbor = n.leftNeighbor ? parseInt(n.leftNeighbor.id) : 0;
			// n0.rightNeighbor = n.rightNeigbor ? parseInt(n.rightNeighbor.id) : 0;
			// n0.parentTree = n.parentTree;
			n0.levelIndex = parseInt(n.levelIndex);
			n0.nodeType = n.nodeType;
			n0.pathwayUrl = n.pathwayUrl;
			n0.calculatorUrl = n.calculatorUrl;
			n0.telephone = n.telephone;
			n0.emailAddress = n.emailAddress;
			n0.nodeFunction = n.nodeFunction;
			n0.shortDescription = n.shortDescription;
			n0.longDescription = n.longDescription;
			n0.riskSeverity = n.riskSeverity;
			n0.careSetting = n.careSetting;
			n0.showInfoBtn = n.showInfoBtn;
			n0.externalUrl = n.externalUrl;
			//n0.undoType = n.undoType;
			n0.sortOrder = parseInt(n.sortOrder);
			n0.parentLabel = n.parentLabel;
			if (!n.line) n0.line = 1;
			else n0.line = n.line;
		}

		return n0;
	}
}
